import { withForm } from '@/components/form';
import { Field, Input, SectionCard } from '@/components/ui';

import type { engagementEnum } from '../../contactSchema';
import { defaultFormValues } from '../../contactSchema';

const ENGAGEMENT_OPTIONS = [
  { value: '', label: '—' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
] satisfies { value: (typeof engagementEnum.options)[number]; label: string }[];

export const RatingSection = withForm({
  defaultValues: defaultFormValues,
  render: function RatingSection({ form }) {
    return (
      <SectionCard title="Rating">
        <div className="ds-form-grid-2">
          <form.AppField name="rating.score">
            {(field) => (
              <Field label="Score (0–100)">
                <Input
                  type="number"
                  min={0}
                  max={100}
                  value={field.state.value ?? ''}
                  onChange={(e) => {
                    const n = e.target.value === '' ? undefined : Number(e.target.value);
                    field.handleChange(n);
                  }}
                  onBlur={field.handleBlur}
                />
              </Field>
            )}
          </form.AppField>
          <form.AppField name="rating.engagement">
            {(field) => <field.Select label="Engagement" options={ENGAGEMENT_OPTIONS} />}
          </form.AppField>
        </div>
      </SectionCard>
    );
  },
});
